
(function () {
  var lastTime = 0
  var vendors = ['webkit', 'moz']
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame']
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || // name has changed in Webkit
                                    window[vendors[x] + 'CancelRequestAnimationFrame']
  }
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback, element) {
      var currTime = new Date().getTime()
      var timeToCall = Math.max(0, 16.7 - (currTime - lastTime))
      var id = window.setTimeout(function () {
        // eslint-disable-next-line standard/no-callback-literal
        callback(currTime + timeToCall)
      }, timeToCall)
      lastTime = currTime + timeToCall
      return id
    }
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id)
    }
  }
}())

const noop = function () {}
export default class CanvasFrame {
  constructor ({ res = [], canvas = null, loop = false, yoyo = false, width = 750, height = 1335, frameRate = 60 } = {}) {
    this.loop = loop
    this.yoyo = yoyo
    this.width = width
    this.height = height
    this.frameRate = frameRate
    this.curIndex = 0
    this.A = null
    this.now = null
    this.canvas = canvas || document.createElement('canvas')
    this.canvas.width = width
    this.canvas.height = height
    this.ctx = this.canvas.getContext('2d')

    if (res.length) {
      res.forEach(r => {
        let { image, height } = r
        r.total = image.height / height
      })
    }
    this.res = res
  }
  play (curIndex) {
    let { res } = this
    if (!res.length) return

    if (!Array.isArray(curIndex)) {
      curIndex = new Array(res.length).fill(curIndex)
    }

    res.forEach((r, index) => {
      r.curIndex = curIndex[index] || 0
    })

    this.now = +new Date()
    this._animation()
  }
  _animation () {
    this.A = requestAnimationFrame(() => {
      this._animation()
    })
    if (+new Date() - this.now >= 1000 / this.frameRate) {
      this.now = +new Date()
      this._draw()
    }
  }
  _draw () {
    let { res, ctx } = this
    ctx.clearRect(0, 0, this.width, this.height)
    res.forEach(r => {
      let { image, width, height, x, y, total, curIndex, callback = noop } = r
      curIndex++
      r.curIndex = curIndex
      if (curIndex >= total) {
        this.ctx.drawImage(image, 0, (curIndex - 1) * height, width, height, x, y, width, height)
        return callback()
      } else {
        this.ctx.drawImage(image, 0, curIndex * height, width, height, x, y, width, height)
      }
    })
  }
  pause () {
    if (this.A) {
      cancelAnimationFrame(this.A)
      this.A = null
    }
  }

  stop () {
    this.pause()
    let { res } = this
    res.forEach((r, index) => {
      r.curIndex = 0
    })
  }
}
